import { RouteNameEnum } from '../enums';

export const scrollMemoryRouteNames: RouteNameEnum[] = [RouteNameEnum.KnowledgeBase];
